import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD, { managers } from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import physics_tool from "../../../../../engines/libs/physics_tool";
import utilsView from "../../../../../engines/libs/utilsView";
import { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";

const { ccclass, property, menu } = cc._decorator;

/**飞刀 撞击反弹  连击数*/
@ccclass
export default class level_flyknife2 extends BasePopUpLayer {
    private readonly KNIFT_FLY_MOVE: number = 600;
    private readonly FLY_TOTAL_TIME: number = 15;
    @property({ type: cc.RigidBody, displayName: "飞刀" })
    private node_flyKnife: cc.RigidBody = null;
    @property({ type: cc.Node, displayName: "飞刀路径" })
    private node_flyKnifeWay: cc.Node = null;

    @property({ type: sp.Skeleton, displayName: "玩家动画" })
    private playerAni: sp.Skeleton = null;

    @property({ type: sp.Skeleton, displayName: "烟雾动画" })
    private smokeAni: sp.Skeleton = null;


    @property({ type: cc.Collider, displayName: "玩家碰撞节点" })
    private playerCollider: cc.Collider = null;

    @property({ type: cc.Node, displayName: "苹果刀" })
    private appleKnife: cc.Node = null;

    @property({ displayName: "保护期时间" })
    private baohutime: number = 0.5;

    @property({ type: cc.Label, displayName: "倒计时" })
    private lab_time: cc.Label = null;

    @property({ displayName: "飞刀的动画名" })
    private aniString: string = "";

    @property({ type: cc.Node, displayName: "提示文字节点" })
    private tipNode: cc.Node = null;

    @property({ type: cc.Node, displayName: "连击" })
    private combo: cc.Node = null;

    @property({ type: cc.Node, displayName: "旋转点" })
    private autoNode: cc.Node = null;

    @property({ displayName: "需要消灭的敌人数" })
    private successKillNum: number = 1;

    fly_Time: number = 0;

    flyknifeInitPos: cc.Vec2 = null;

    touchPos: cc.Vec2 = null;
    flyAngle: number = null;

    isFly: boolean = false;

    private comboNum: number = 0

    private killNum: number = 0
    onLoad() {

        this.node.on(cc.Node.EventType.TOUCH_START, this.onTouchStart, this)
        this.node.on(cc.Node.EventType.TOUCH_MOVE, this.onTouchMove, this)
        this.node.on(cc.Node.EventType.TOUCH_CANCEL, this.onTouchEnd, this)
        this.node.on(cc.Node.EventType.TOUCH_END, this.onTouchEnd, this)
        this.playerCollider.enabled = false

        this.tipNode.active = false
        // cc.tween(this.tipNode)
        // .repeatForever(
        //     cc.tween()
        //     .to(1,{opacity:0})
        //     .to(1,{opacity:255})
        // )
        // .start()

        if (this.autoNode) {
            cc.tween(this.autoNode)
                .repeatForever(
                    cc.tween(this.autoNode)

                        .to(1, { angle: -359 })
                        .call(
                            () => {
                                this.autoNode.angle = 0
                            }
                        )
                )
                .start()
        }

        this.touchPos = null;
        this.node_flyKnifeWay.active = false;
        this.isFly = false;
        this.node_flyKnife.node.active = false;

       
        this.flyAngle = this.node_flyKnife.node.angle;
        this.fly_Time = 0;

    }



    protected start(): void {
        this.playerAni.setAnimation(0,'Idle', true);
        // for (let index = 0; index < this.node.children[0].childrenCount; index++) {
        //     const element = this.node.children[0].children[index];
        //     element.addComponent(widgetNode)
        // }
        
        (<any>this.node_flyKnife.getComponent(cc.Component)).onCollisionEnter = (other, self) => {
            // this.showCombo(this.comboNum)
            this.comboNum += 1
            if (other.node.name == "targetNode") {
                this.smokeAni.node.active = true
    
                this.smokeAni.node.setPosition(other.node.position.x,other.node.position.y)
                this.smokeAni.setAnimation(0, "play", false)
                this.scheduleOnce(() => {
                    if (other.node) {
                        this.killNum += 1
                        other.node.destroy()
                        managers().soundMgr.playSound('flyKnife', null, BUNDLE_SMALL_NAME.fddsMode);
                        if (this.killNum >= this.successKillNum) {
                            this.gameOver(true)
                        }
                    }

                }, 0.2)

            } else if (other.node.name == "playNode") {
                this.smokeAni.node.setPosition(other.node.position.x, other.node.position.y)
                this.smokeAni.node.active = true
                this.smokeAni.setAnimation(0, "play", false)
                this.scheduleOnce(() => {
                    other.node && other.node.destroy()
                }, 0.2)
            }

            switch (Number(other.tag)) {
                case 2: //碰到自己
                    managers().soundMgr.playSound('flyKnife', null, BUNDLE_SMALL_NAME.fddsMode);
                   
                    this.gameOver(false)
                    break;
                case 3: //碰到敌人


                    break;
                case 4: //碰到苹果
                    managers().soundMgr.playSound('cutApple', null, BUNDLE_SMALL_NAME.fddsMode);
                    this.gameOver(true)
                    this.appleKnife && (this.appleKnife.active = true)
                    break;
                default:

                    managers().soundMgr.playSound('tandao', null, BUNDLE_SMALL_NAME.fddsMode);
            }


        }


    }
    // protected update(dt: number): void {
    //     if (!this.isFly || this.isDone) return
    //     if (this.isFly) {
    //         this.fly_Time += dt;
    //         this.lab_time.string = "倒计时：" + Math.floor(this.FLY_TOTAL_TIME - this.fly_Time)

    //         if (this.fly_Time >= this.FLY_TOTAL_TIME) {
    //             this.gameOver(false)
    //             this.node_flyKnife.node.active = true
    //         }
    //     }
    // }
    // async Init(info: INormalLevelStruct) {
    //     super.Init(info);
    //     // this.node.setPosition(cc.v2(cc.winSize.width * -0.5, cc.winSize.height * -0.5));
    // }
    onTouchStart(event: cc.Event.EventTouch) {
        this.tipNode.active = false
        this.flyknifeInitPos = cc.v2(this.node_flyKnife.node.x, this.node_flyKnife.node.y );
        this.node_flyKnifeWay.setPosition(this.flyknifeInitPos);
        if (this.isFly || this.isDone) return
        this.touchPos = this.node_flyKnife.node.parent.convertToNodeSpaceAR(event.getLocation());
        this.setKnifeWay()

    }
    onTouchMove(event: cc.Event.EventTouch) {
        if (this.isFly || this.isDone) return

        this.touchPos = this.node_flyKnife.node.parent.convertToNodeSpaceAR(event.getLocation());
        this.setKnifeWay()
    }
    onTouchEnd(event: cc.Event.EventTouch) {
        if (this.isFly || this.isDone) return
        this.scheduleOnce(() => {  //保护期
            this.playerCollider.enabled = true
        }, this.baohutime)
        // let pos = this.node_flyKnife.parent.convertToNodeSpaceAR(event.getLocation());
        this.touchPos = null
        this.setKnifeWay()

        this.isFly = true;

        let aniTrack = this.playerAni.setAnimation(0,'Throw',false);
        this.scheduleOnce(()=>{
            this.node_flyKnife.node.active = true;
            this.node_flyKnife.linearVelocity = cc.v2(0, this.KNIFT_FLY_MOVE).rotate(Math.PI * (this.flyAngle / 180));
        }, aniTrack.animation.duration-0.2)

        this.playerAni.setCompleteListener((ani: sp.spine.TrackEntry)=> {
            if (ani.animation.name == 'Throw') {
                this.playerAni.setAnimation(0,'Idle2', true);
            }
        });
    }

    setKnifeWay() {
        if (this.touchPos == null) {
            this.node_flyKnifeWay.active = false;
            return
        }
        this.node_flyKnifeWay.active = true;
        this.node_flyKnifeWay.setPosition(this.flyknifeInitPos);
        let a = this.node_flyKnife.node.parent.convertToWorldSpaceAR(this.touchPos)
        let b = this.node_flyKnife.node.parent.convertToWorldSpaceAR(this.flyknifeInitPos)

        this.node_flyKnifeWay.angle = -data_control.GetAngle(a.sub(b));
        this.node_flyKnife.node.angle = -data_control.GetAngle(a.sub(b));
        this.flyAngle = this.node_flyKnifeWay.angle;

        this.node_flyKnifeWay.height = a.sub(b).mag()
    }
    isDone: boolean = false;
    gameOver(win: boolean) {
        if (this.isDone)
            return
        this.isDone = true;


        // this.node_flyKnife.linearVelocity = cc.v2(0, 0);

        this.node_flyKnife.node.active = false;
        this.scheduleOnce(() => {
            //TODO 判断胜利或者失败
            // win ? this.Win(cc.v2()) : this.Lose(cc.v2());
            if (win) {
                this.gameWin();
            } else {
                utilsView.openPopupLayer(
                    'prefab/FddsLosePage'
                    , BUNDLE_SMALL_NAME.fddsMode
                    , null
                    , {
                        parent: this
                    }
                )
            }
        }, 0.01)

    }

    private comboLabel: cc.Label = null
    showCombo(v: number) {
        if (this.comboLabel == null) {
            this.comboLabel = this.combo.getComponentInChildren(cc.Label)
        }
        this.combo.opacity = 255;
        this.comboLabel.node.stopAllActions()
        this.comboLabel.node.scale = 0.5;
        this.comboLabel.string = "X " + v.toString();
        this.comboLabel.node.runAction(cc.sequence(cc.scaleTo(0.2, 0.8).easing(cc.easeBackOut()), cc.delayTime(1.5), cc.fadeOut(0.06)))
    }

    gameWin() {
        // this.destroyNode();
        this._carryData.parent.nextLevel(this.node);
    }

    exitLayer() {
        this._carryData.parent.closeLayer();
    }

    resetStart() {
        this.destroyNode();
        this._carryData.parent.resetStartLevel();
    }

    // onDestroy(){
    //     physics_tool.closePhysics();
    //     physics_tool.closeCollision();
    // }
}